module.exports = __webpack_public_path__ + "img/empty-profile.8ceb3ccb.jpg";